import React from "react";
import styled from "styled-components";
import { prices, reducedVariants } from "../new-prices-20240411";

const Input = styled.input`
  margin-left: 12px;
  margin-right: 12px;
`;

const discounts = [
  { xOrMore: 2, discont: 0.25 },
  { xOrMore: 3, discont: 0.4 },
  { xOrMore: 5, discont: 0.45 },
  { xOrMore: 10, discont: 0.65 },
  { xOrMore: 25, discont: 0.7 },
  { xOrMore: 50, discont: 0.75 },
  { xOrMore: 100, discont: 0.8 },
  { xOrMore: 250, discont: 0.85 },
  { xOrMore: 500, discont: 0.9 },
];

//Aufpreis fuer mehrere Farben definieren
// const aufpreisFuerFarbe = 3

export default function PriceCalculator(props) {
  console.log({ props });
  function getDiscount(x) {
    let discount = 0;

    for (let i = 0; i < discounts.length; i++) {
      if (x >= discounts[i]?.xOrMore) {
        discount = discounts[i]?.discont;
      } else {
        break;
      }
    }

    return discount;
  }
  const inputField = props.lastUserInputField;
  const input = props.lastUserInput;
  const ratio = props.ratio;
  let hoeheBerechnet = input / ratio;
  hoeheBerechnet = hoeheBerechnet.toFixed(1);
  let breiteBerechnet = input * ratio;
  breiteBerechnet = breiteBerechnet.toFixed(1);
  let hoehe = inputField === "breite" ? hoeheBerechnet : input;
  let breite = inputField === "hoehe" ? breiteBerechnet : input;
  let flaecheInCM = breite * hoehe;
  let flaeche = flaecheInCM / 10000;
  let preis;
  let priceWithoutDiscount;
  if (
    props.folienTyp === "Matt" ||
    props.folienTyp === "Standard" ||
    props.folienTyp === "Milchglas"
  ) {
    //y = -0,7121x4 + 7,1569x3 - 27,535x2 + 73,575x + 6,1129
    let a = 0.7121 * flaeche * flaeche * flaeche * flaeche;
    let b = 7.1569 * flaeche * flaeche * flaeche;
    let c = 27.535 * flaeche * flaeche;
    let d = 73.575 * flaeche;
    let e = 5.2629; // -0.85 wurde abgezogen
    // console.log("preis before: ", b - c + d + e - a);
    priceWithoutDiscount = b - c + d + e - a;
    preis = b - c + d + e - a - (b - c + d + e - a) * getDiscount(props?.menge);
    let counter = 0;
    let result = 6;
    (function () {
      for (let i = 0; i < prices.length; i++) {
        if (preis <= prices[i]) {
          result = i;
          return;
        }
        counter = counter + 1;
      }
    })();
    preis = prices[result];
    if (preis < 6 * getDiscount(props?.menge)) {
      preis = 6 * getDiscount(props?.menge);
    }
    //check
    let counter2 = 0;
    let result2 = 6;
    (function () {
      for (let i = 0; i < prices.length; i++) {
        if (priceWithoutDiscount <= prices[i]) {
          result2 = i;
          return;
        }
        counter2 = counter2 + 1;
      }
    })();
    priceWithoutDiscount = prices[result2];
    if (priceWithoutDiscount < 6) {
      priceWithoutDiscount = 6;
    }
  } else if (
    props.folienTyp === "Hochwertig" ||
    props.folienTyp === "MattPremium"
  ) {
    //y = 1,5873x3 - 15,106x2 + 75,658x + 8,4825
    let a = 1.5873 * flaeche * flaeche * flaeche;
    let b = 15.106 * flaeche * flaeche;
    let c = 75.658 * flaeche;
    let d = 7.2425; // -1.24 wurde abgezogen
    priceWithoutDiscount = a - b + c + d;
    preis = a - b + c + d - (a - b + c + d) * getDiscount(props?.menge);
    let counter = 0;
    let result = 8;
    (function () {
      for (let i = 0; i < prices.length; i++) {
        if (preis <= prices[i]) {
          result = i;
          return;
        }
        counter = counter + 1;
      }
    })();
    preis = prices[result];

    if (preis < 8 * getDiscount(props?.menge)) {
      preis = 8 * getDiscount(props?.menge);
    }

    let counter2 = 0;
    let result2 = 8;
    (function () {
      for (let i = 0; i < prices.length; i++) {
        if (priceWithoutDiscount <= prices[i]) {
          result2 = i;
          return;
        }
        counter2 = counter2 + 1;
      }
    })();
    priceWithoutDiscount = prices[result2];
    if (priceWithoutDiscount < 8) {
      priceWithoutDiscount = 8;
    }
  }

  const gesamtpreis = (preis + props.farbenAufpreis) * props.menge;
  const itemPrice = priceWithoutDiscount + props.farbenAufpreis;
  const discountPercentage = getDiscount(props.menge);
  const reducedItemPreis = itemPrice - itemPrice * discountPercentage;

  let variantId = null;
  let priceFoundInArray = null;
  prices.forEach((price, id) => {
    if (price >= reducedItemPreis && !variantId) {
      variantId = id;
      priceFoundInArray = price;
    }
  });

  const total = priceFoundInArray * props.menge;

  return (
    <div className="auswahl">
      {props.preisError ? (
        <div>
          <p id="error-text">{props.errorText}</p>
        </div>
      ) : (
        <div></div>
      )}
      <form className="mk-form">
        {!props.preisError ? (
          <>
            <label className="mk-label" htmlFor="menge">
              Menge:
            </label>
            <Input
              className="mk-input"
              type="number"
              id="menge"
              name="menge"
              onChange={props.setMenge}
              value={props.menge}
            ></Input>
            <label className="mk-label" htmlFor="preis" id="x">
              x
            </label>
            <div>
              {getDiscount(props?.menge) ? (
                <div style={{ display: "flex" }}>
                  <label
                    className="mk-label"
                    style={{ textDecoration: "line-through" }}
                    htmlFor="preis"
                  >
                    {itemPrice.toFixed(2).replace(/\.(\d)$/, ".$10")}
                    {" EUR"}
                  </label>
                </div>
              ) : null}
              <div style={{ display: "flex" }}>
                <label className="mk-label" htmlFor="preis">
                  {priceFoundInArray?.toFixed(2).replace(/\.(\d)$/, ".$10")}
                  {" EUR"}
                </label>
                <label className="mk-label" htmlFor="preis">
                  Stückpreis
                </label>
              </div>
            </div>
          </>
        ) : (
          <>
            <label className="mk-label" htmlFor="menge">
              Menge:
            </label>
            <Input
              className="mk-input"
              type="number"
              id="menge"
              name="menge"
              onChange={props.setMenge}
              value={props.menge}
            ></Input>

            <label id="error-text">Nicht verfügbar!</label>
          </>
        )}
      </form>
      {getDiscount(props?.menge) ? (
        <label>
          Gesamtpreis: {total?.toFixed(2)} (Du sparst ca.{" "}
          {getDiscount(props?.menge) * 100}%)
        </label>
      ) : (
        <label>Gesamtpreis: {total?.toFixed(2)}</label>
      )}
      <table border="1" style={{ marginTop: "32px" }}>
        <tbody>
          <tr>
            <th style={{ backgroundColor: "#597282", color: "#fff" }}>Menge</th>
            <th style={{ backgroundColor: "#597282", color: "#fff" }}>
              Rabatt
            </th>
          </tr>
          <tr>
            <td>Kaufe 2+</td>
            <td>25%</td>
          </tr>
          <tr>
            <td>Kaufe 3+</td>
            <td>40%</td>
          </tr>
          <tr>
            <td>Kaufe 5+</td>
            <td>45%</td>
          </tr>
          <tr>
            <td>Kaufe 10+</td>
            <td>65%</td>
          </tr>
          <tr>
            <td>Kaufe 25+</td>
            <td>70%</td>
          </tr>
          <tr>
            <td>Kaufe 50+</td>
            <td>75%</td>
          </tr>
          <tr>
            <td>Kaufe 100+</td>
            <td>80%</td>
          </tr>
          <tr>
            <td>Kaufe 250+</td>
            <td>85%</td>
          </tr>
          <tr>
            <td>Kaufe 500+</td>
            <td>90%</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
